var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18997_314",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18997_314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40H28V32H20V40ZM8 28H16V20H8V28ZM20 28H28V20H20V28ZM32 28H40V20H32V28ZM32 16H40V8H32V16ZM16 44V32H4V16H28V4H44V32H32V44H16Z",
    fill: "#F1F7F7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModular);
export default __webpack_public_path__ + "static/media/modular.e18c0b6347aa9566acbf58d8b08b9a61.svg";
export { ForwardRef as ReactComponent };